/* kc-toc.js — builds a table of contents from the headings an article already has.
 *
 * WHY CLIENT-SIDE: the article body is a single rich-text field. Liquid cannot
 * parse it into headings, and hand-writing a TOC into every article body would
 * drift the moment a heading is edited. Deriving it from the rendered DOM means
 * the TOC is always exactly the article's own structure.
 *
 * PROGRESSIVE ENHANCEMENT: the container is empty and hidden in the markup, so
 * a reader without JavaScript sees the article with no broken furniture. Nothing
 * here invents content — it only links to headings that already exist.
 *
 * Long guides only: a TOC over two headings is noise, so it is skipped.
 */
(function () {
  'use strict';
  var MIN_HEADINGS = 3;

  function slug(t, i) {
    var s = (t || '').toString().trim().toLowerCase()
      .replace(/[^\p{L}\p{N}\s-]/gu, '')
      .replace(/\s+/g, '-')
      .slice(0, 60);
    return s ? 'sec-' + s : 'sec-' + i;
  }

  function build(root) {
    var body = document.querySelector(root.dataset.kcTocFor || '.kart__body');
    if (!body) return;
    var hs = Array.prototype.slice.call(body.querySelectorAll('h2'));
    if (hs.length < MIN_HEADINGS) return;

    var isAr = root.dataset.lang === 'ar';
    var used = {};
    var list = document.createElement('ol');
    list.className = 'kctoc__list';

    hs.forEach(function (h, i) {
      var id = h.id;
      if (!id) {
        id = slug(h.textContent, i);
        while (used[id]) { id = id + '-' + i; }
        h.id = id;
      }
      used[id] = true;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });

    var head = document.createElement('h2');
    head.className = 'kctoc__h';
    head.textContent = isAr ? 'محتويات الدليل' : 'In this guide';

    root.appendChild(head);
    root.appendChild(list);
    root.hidden = false;
  }

  function init() {
    document.querySelectorAll('[data-kc-toc]').forEach(build);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
